import store from '@/store'
import request from '@/api/axioRequest.js'

export default {
  getRules () {
    return request.get('rules/get/')
      .then(response => {
        if (!response.error) {
          store.commit('setRules', response)
          store.commit('setConstRules', JSON.parse(JSON.stringify(response)))
          return response
        }
      })
  },
  postSoqlRule (rule) {
    return request.post('rules/soql/', rule)
      .then(response => {
        store.commit('updateConstRule', rule)
        return response
      })
  },
  postSimpleRule (rule) {
    return request.post('rules/simple/', rule)
      .then(response => {
        store.commit('updateConstRule', rule)
        return response
      })
  },
  postRuleDelete (rule) {
    return request.post('rules/delete/', rule)
  },
  soqlValid (data) {
    return request.post('salesforce/testsoql/', data)
  },
  simpleSoqlValidSalesforce (data) {
    return request.post('salesforce/testsimple/', { 'crm_connection_id': data.crm_connection_id, data })
  },
  simpleSoqlValidDynamics (data) {
    return request.post('dynamics/testsimple/', { 'crm_connection_id': data.crm_connection_id, data })
  }
}
